/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input, OnChanges } from '@angular/core';

/** Minimal user shape needed to render a profile image or initials fallback. */
export interface ProfileImageSummary {
  firstName: string;
  imageUrl?: string;
}

@Component({
  selector: 'ptl-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss'],
})
export class ProfileImageComponent implements OnChanges {
  /** Defines the image(or initials in the case of missing image) to be displayed.  */
  @Input() userSummary: ProfileImageSummary;

  userInitial: string;

  ngOnChanges() {
    if (this.userSummary) {
      this.userInitial = this.userSummary.firstName.charAt(0);
    }
  }
}
